// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__2zMbv","menuList":"menu_menuList__2_4-R","menuButton":"menu_menuButton__3IXV6"};